import { render, staticRenderFns } from "./DetailSoftware.vue?vue&type=template&id=0f4e7698"
import script from "./DetailSoftware.vue?vue&type=script&lang=js"
export * from "./DetailSoftware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports